<template>
  <div class="sidebar">
    <ul>
      <li
        v-for="item of list"
        :key="item.cat_id"
        @click="select(item.cat_id)"
        :class="active == item.cat_id ? 'select' : ''"
      >
        {{ item.cat_name }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number
    },
  },
  model: {
    prop: 'active',
    event: 'activeId'
  },
  data () {
    return {
    }
  },
  methods: {
    select (id) {
      if (id !== this.active) {
        this.$emit('activeId', id)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.sidebar {
  font-size: 0.23rem;
  background: #fff;


  ul {
    min-width: 25vw;

    li {
      width: 25vw;
      padding: 0.3rem 0.2rem;
      font-size: 0.28rem;
      text-align: center;
    }
  }

  .select {
    color: $globalcolor;
    position: relative;
    background: #f6f6f6;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 0.15rem;
      height: 100%;
      background: $globalcolor;
    }
  }
}
</style>
